/**
 * 邮箱图标
 */
const EmailIcon = ({ width = 16, height = 16, color = '#444446' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_49777_30002)">
        <path d="M2 5V12.3333H14V5" stroke={color} strokeWidth="1.33333" />
        <path
          d="M2 3.66797H14V5.0013L8 8.33464L2 5.0013L2 3.66797Z"
          stroke={color}
          strokeWidth="1.33333"
        />
      </g>
      <defs>
        <clipPath id="clip0_49777_30002">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default EmailIcon
